import { React, useEffect, useRef, useState } from "react";
import Block from "./Block/Block";
import { useDispatch, useSelector } from "react-redux";
import "./Preview.css";
import { updateCurrentBlockState } from "../../../Redux/actions/projectActions";
import "../../../assets/styles/FontsStyle.css";
// import watermarkimg from "../../../assets/icons/Scrollx_Black.png"
import scrollxLogo from "../../../assets/icons/Brand_Logos/ScrollX_LOGO_White_new.png";

const blockInsetClass = {
  default: "float-none w-[100%] ",
  left: "mr-[50%] w-[50%] float-left",
  right: "ml-[50%] w-[50%] float-right",
};
const focusDiv = (idx, currentIdx) => {
  if (idx === currentIdx) {
    return "focusDiv";
  } else {
    return "";
  }
};

const scrollTo = (parent, child, slct, size) => {
  let parent1 = document.getElementById(parent);
  let child1 = document.getElementById(child);

  //   if (child1 && parent1)
  //     parent1?.scrollTo({
  //       behavior: "smooth",
  //       top: slct === 'font' ? child1.offsetTop - document.getElementById("navbar_1").offsetHeight + (size.winWidth <= '1800' ? (size.winWidth <= '1600' ? 52.5 : 55) : 1) : child1.offsetTop - document.getElementById("navbar_1").offsetHeight - 260,
  //     });
  // };
  if (child1 && parent1)
    parent1?.scrollTo({
      behavior: "smooth",
      top:
        slct === "font"
          ? child1.offsetTop -
            document.getElementById("navbar_1").offsetHeight +
            (size.winWidth <= "2560"
              ? size.winWidth <= "2310"
                ? size.winWidth <= "2050"
                  ? size.winWidth <= "1950"
                    ? size.winWidth <= "1800"
                      ? size.winWidth <= "1600"
                        ? 52.5
                        : 55
                      : -12
                    : -20
                  : -25
                : -36
              : -50)
          : child1.offsetTop -
            document.getElementById("navbar_1").offsetHeight -
            260,
    });
};

const endLines = (extra_lines_below, idx) => {
  if (extra_lines_below !== "") {
    return (
      <div id={idx + "endlines"}>
        {[...Array(extra_lines_below)].map((e, i) => (
          <br></br>
        ))}
      </div>
    );
  } else {
    return <div id={idx + "endlines"}></div>;
  }
};

export default function Preview({ projectData, isFullscreen, exitFullscreen }) {
  const dispatch = useDispatch();
  const previewRef = useRef(null);
  const { gobalBGcolor } = useSelector((state) => state?.commonReducer);
  const isOptionSelected = useSelector(
    (state) => state.commonReducer.isOptionSelected
  );
  // console.log(' Preview isOptionSelected === ', isOptionSelected);

  const [size, setSize] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });
  const detectSize = () => {
    setSize({ winWidth: window.innerWidth, winHeight: window.innerHeight });
  };
  useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [size]);

  useEffect(() => {
    scrollTo("preview", "view_", isOptionSelected, size);
  });

  const onclick = (currentCreditBlockId, idx) => {
    dispatch(updateCurrentBlockState(currentCreditBlockId, idx));
    scrollTo("preview", "view_" + idx, isOptionSelected, size);
    scrollTo("content", "content" + idx, size);
  };

  const currentBlockIdx = projectData?.currentBlock?.idx;
  useEffect(() => {
    try {
      scrollTo("preview", "view_" + currentBlockIdx, isOptionSelected, size);
      scrollTo("content", "content" + currentBlockIdx, size);
    } catch (error) {
      console.log(error);
    }
  }, [currentBlockIdx, isOptionSelected]);

  const blockArr = projectData?.credits?.map(({ options, items, _id }, idx) => {
    return {
      block: (
        <div
          key={idx}
          className={
            "" +
            blockInsetClass[options.block_inset] +
            " viewBlock" +
            focusDiv(idx, currentBlockIdx)
          }
          block-title={options.block_name}
          onClick={(e) => {
            onclick(_id, idx);
          }}
          style={{ margin: `${options.margin_vertical}px 0` }}
        >
          {projectData?.settings && (
            <Block
              options={options}
              items={items}
              idx={idx}
              settings={projectData?.settings}
            />
          )}
          {endLines(options.extra_lines_below, idx)}
        </div>
      ),
      idx: idx,
      side_by_side: options.block_inset,
    };
  });

  let sideBySideBlocks = [];
  const { previewWidth, previewScale } = useSelector(
    (state) => state?.application
  );

  return (
    <div className="previewCnt h-full">
      <div id="preview" className={"  scrollable"} ref={previewRef}>
        {blockArr?.map((data, idx) => {
          if (data.side_by_side === "sidebyside") {
            sideBySideBlocks.push(idx, idx + 1);
            return (
              <div
                id={"view_" + idx}
                className={"blockWrapper pr-prants"}
                style={{
                  // width: `${previewWidth * previewScale}px`
                  width: isFullscreen
                    ? "100%"
                    : `${previewWidth * previewScale}px`,

                  // , backgroundColor: gobalBGcolor
                }}
              >
                <div className={"watermark_displaynone"}></div>
                <div
                  className="flex flex-row gap-x-[30px]"
                  style={{
                    width: `${previewWidth}px`,
                    transform: `scale(${previewScale})`,
                    transformOrigin: "top left",
                  }}
                >
                  <div
                    className={
                      "w-[50%] " + (idx === currentBlockIdx ? "focusDiv" : "")
                    }
                  >
                    {data.block}
                  </div>
                  <div
                    className={
                      "w-[50%] " +
                      (idx + 1 === currentBlockIdx ? "focusDiv" : "")
                    }
                  >
                    {blockArr[idx + 1]?.block}
                  </div>
                </div>
              </div>
            );
          } else {
            if (blockArr[idx - 1]?.side_by_side !== "sidebyside") {
              return (
                <div
                  id={"view_" + idx}
                  className={
                    "blockWrapper pr-prants " +
                    (idx === currentBlockIdx ? "focusDiv" : "")
                  }
                  style={{
                    width: isFullscreen
                      ? "100%"
                      : `${previewWidth * previewScale}px`,
                    // backgroundColor: gobalBGcolor
                  }}
                >
                  <div className={"watermark_displaynone"}></div>
                  <div
                    style={{
                      width: isFullscreen ? "100%" : `${previewWidth}px`,
                      transform: `scale(${previewScale})`,
                      transformOrigin: "top left",
                    }}
                  >
                    {data.block}
                  </div>
                </div>
              );
            }
          }
        })}
      </div>

      {isFullscreen && <img src={scrollxLogo} alt="" className="fss2" />}

      {isFullscreen && (
        <button
          type="button"
          onClick={exitFullscreen}
          className={isFullscreen ? "fss" : "d-none"}
        >
          <span className="uppercase Syne700">EXIT</span>
        </button>
      )}
    </div>
  );
}
